import { ReactNode } from "react";
import { Link, useHistory } from "react-router-dom";
import tw from "src/utils/tw";

interface Props {
  onClick?: () => void;
  children: ReactNode;
  to?: string;
  className?: string;
  disabled?: boolean;
  href?: string;
  target?: string;
}

export function MenuButton(props: Props) {
  const history = useHistory();

  function onClick() {
    if (props.to) {
      history.push(props.to);
    } else {
      props.onClick();
    }
  }

  const className = tw(
    "block h-11 w-full text-center text-organization border-b border-borderGray px-4 text-sm font-bold transition hover:bg-bgGray active:bg-bgGray truncate",
    props.disabled && "opacity-50",
    props.className
  );

  if (props.to) {
    return (
      <Link className={tw("pt-3", className)} to={props.to}>
        {props.children}
      </Link>
    );
  }

  if (props.href) {
    return (
      <a
        href={props.href}
        target={props.target}
        className={tw(className, "py-2.5")}
      >
        {props.children}
      </a>
    );
  }

  return (
    <button className={className} onClick={onClick} disabled={props.disabled}>
      {props.children}
    </button>
  );
}
